import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
import "./SetPasswordPage.css";

import {
  verifyInviteApi,
  setPasswordApi,
} from "../../../../Services/AddclientsService/AddclioentsApi";

import PasswordInput from "../../../../Components/CommonUI/Input/Password";
import { Formik, Form, ErrorMessage } from "formik";

import { setPasswordValidationSchema } from "./SetPasswordPage.schema";

type VerificationState =
  | { status: "loading" }
  | { status: "success" }
  | { status: "error"; message: string };
const LoadingCard: React.FC = () => (
  <div className="card">
    <div className="spinner" />
    <p>Verification in progress. Please wait...</p>
  </div>
);

const ErrorCard: React.FC<{ message: string }> = ({ message }) => (
  <div className="card">
    <h3>Link Invalid</h3>
    <p>{message}</p>
  </div>
);

interface PasswordFormProps {
  email?: string;
  fullName?: string;
  onSubmit: (password: string) => void;
}

const PasswordForm: React.FC<PasswordFormProps> = ({
  email,
  fullName,
  onSubmit,
}) => (
  <div className="card">
    <h3>Hi {fullName},</h3>
    <h2>Set Your New Password</h2>

    <Formik
      initialValues={{ password: "", confirmPassword: "" }}
      validationSchema={setPasswordValidationSchema}
      onSubmit={(values) => onSubmit(values.password)}
    >
      {({ values, setFieldValue }) => (
        <Form className="form-table">
          <div className="form-row">
            <label>Email</label>
            <input
              type="email"
              value={email ?? ""}
              disabled
              className="form-input form-input--disabled"
            />
          </div>

          <div className="form-row">
            <label>
              Password <span className="required">*</span>
            </label>
            <PasswordInput
              value={values.password}
              onChange={(val) => setFieldValue("password", val)}
              placeholder="Enter Password"
              className="form-input"
            />
            <div className="error">
              <ErrorMessage name="password" />
            </div>
          </div>

          <div className="form-row">
            <label>
              Confirm Password <span className="required">*</span>
            </label>
            <PasswordInput
              value={values.confirmPassword}
              onChange={(val) => setFieldValue("confirmPassword", val)}
              placeholder="Confirm Password"
              className="form-input"
            />
            <div className="error">
              <ErrorMessage name="confirmPassword" />
            </div>
          </div>

          <button type="submit" className="button">
            Set Password
          </button>
        </Form>
      )}
    </Formik>
  </div>
);

export const SetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { token, email, fullName } = useParams();
  const [state, setState] = useState<VerificationState>({ status: "loading" });

  useEffect(() => {
    if (!token) {
      setState({ status: "error", message: "Invalid link." });
      return;
    }

    let cancelled = false;

    verifyInviteApi(token)
      .then(() => {
        if (!cancelled) setState({ status: "success" });
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        const message =
          error instanceof Error
            ? error.message
            : "Verification failed. The link may be invalid or expired.";
        setState({ status: "error", message });
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  const handleSetPassword = async (password: string) => {
    try {
      await setPasswordApi(token!, password);
      navigate("/login");
    } catch {
      AlertMessage({ text: "Failed to set password", type: "error" });
    }
  };

  switch (state.status) {
    case "loading":
      return <LoadingCard />;
    case "error":
      return (
        <ErrorCard
          message={
            state.message ||
            "Verification failed. The link may be invalid or expired."
          }
        />
      );
    case "success":
      return (
        <PasswordForm
          email={email}
          fullName={fullName}
          onSubmit={handleSetPassword}
        />
      );
  }
};

// export const SetPasswordPage: React.FC = () => {
//   const navigate = useNavigate();
//   const { token, email, fullName } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [verified, setVerified] = useState(false);
//   const [errorMessage, setErrorMessage] = useState<string>("");
//   useEffect(() => {
//     const verifyToken = async () => {
//       if (!token) {
//         AlertMessage({ text: "Invalid link", type: "error" });
//         setLoading(false);
//         return;
//       }

//       try {
//         await verifyInviteApi(token);
//         setVerified(true);
//       } catch (error) {
//         console.log("erororrheree");
//         return VerificationFailed(
//           "Verification failed. The link may be invalid or expired.",
//         );

//         //  error.message : "Verification failed",

//         // setVerified(false);
//       } finally {
//         setLoading(false);
//       }
//     };

//     verifyToken();
//   }, [token]);

//   const handleSubmit = (values: {
//     password: string;
//     confirmPassword: string;
//   }) => {
//     setPasswordApi(token!, values.password)
//       .then(() => {
//         navigate("/login");
//       })
//       .catch(() =>
//         AlertMessage({ text: "Failed to set password", type: "error" }),
//       );
//   };

//   if (loading) {
//     return (
//       <div className="card">
//         <div className="spinner"></div>
//         <p>Verification in progress. Please wait...</p>
//       </div>
//     );
//   }

//   // if (!verified) {
//   // }

//   return (
//     <div className="card">
//       <h3>Hi {fullName},</h3>
//       <h2>Set Your New Password</h2>

//       <Formik
//         initialValues={{ password: "", confirmPassword: "" }}
//         validationSchema={setPasswordValidationSchema}
//         onSubmit={handleSubmit}
//       >
//         {({ values, setFieldValue }) => (
//           <Form className="form-table">
//             <div className="form-row">
//               <label>Email</label>
//               <input
//                 type="email"
//                 value={email}
//                 disabled
//                 style={{
//                   width: "100%",
//                   height: "38px",
//                   borderRadius: "6px",
//                   padding: "0 10px",
//                   border: "1px solid #ccc",
//                   fontSize: "var(--font-size-base)",
//                   backgroundColor: "#f5f5f5",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>

//             <div className="form-row">
//               <label>
//                 Password <span className="required">*</span>
//               </label>
//               <PasswordInput
//                 value={values.password}
//                 onChange={(val) => setFieldValue("password", val)}
//                 placeholder="Enter Password"
//                 style={{
//                   width: "100%",
//                   height: "38px",
//                   borderRadius: "6px",
//                   paddingLeft: "10px",
//                   border: "1px solid #ccc",
//                   fontSize: "var(--font-size-base)",
//                   boxSizing: "border-box",
//                 }}
//               />
//               <div className="error">
//                 <ErrorMessage name="password" />
//               </div>
//             </div>

//             <div className="form-row">
//               <label>
//                 Confirm Password <span className="required">*</span>
//               </label>
//               <PasswordInput
//                 value={values.confirmPassword}
//                 onChange={(val) => setFieldValue("confirmPassword", val)}
//                 placeholder="Confirm Password"
//                 style={{
//                   width: "100%",
//                   height: "38px",
//                   borderRadius: "6px",
//                   paddingLeft: "10px",
//                   border: "1px solid #ccc",
//                   fontSize: "var(--font-size-base)",
//                   boxSizing: "border-box",
//                 }}
//               />
//               <div className="error">
//                 <ErrorMessage name="confirmPassword" />
//               </div>
//             </div>

//             <button type="submit" className="button">
//               Set Password
//             </button>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };
